import React from 'react';
import {
  Box, Button, Card, CardContent, Dialog, DialogContent, DialogTitle, Grid, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  open: boolean;
  onClose: () => void;
}

const SlaInstructionModal = ({ open, onClose }: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="md"
    fullWidth
    scroll="paper"
  >
    <DialogTitle>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <span>Prazos de coleta e entrega</span>
        <IconButton onClick={onClose} aria-label="Fechar">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent dividers>
      <Card className="card-box mb-3">
        <CardContent>
          <h6 className="font-weight-bold mb-2">O que você acompanha nesta tela</h6>
          <p className="mb-0 text-black-50">
            O relógio mostra se a corrida ainda cabe no prazo combinado, para o gestor agir
            antes da reclamação. O tempo vem dos limites da chamada. Sem prazo cadastrado,
            o relógio não aparece.
          </p>
        </CardContent>
      </Card>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card className="card-box h-100">
            <CardContent>
              <h6 className="font-weight-bold mb-2">Como ler o relógio</h6>
              <p className="mb-2">
                Na coluna
                {' '}
                <strong>Status</strong>
                , abaixo da situação da corrida, veja o tempo restante e o total
                {' '}
                <span className="badge badge-success">02:30/05:00</span>
                {' '}
                e a
                {' '}
                <strong>hora prevista</strong>
                {' '}
                da coleta ou da entrega.
              </p>
              <ul className="pl-3 mb-0">
                <li className="mb-1">Em vários destinos, a hora prevista do destino atual soma a duração dos anteriores.</li>
                <li>
                  Em
                  {' '}
                  <strong>Aguardando</strong>
                  {' '}
                  e
                  {' '}
                  <strong>Encaminhada</strong>
                  , o relógio de aceite é de 5 minutos (alerta aos 3 minutos).
                </li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card className="card-box h-100">
            <CardContent>
              <h6 className="font-weight-bold mb-2">Cores e barra da linha</h6>
              <p className="mb-2">
                Cada linha com prazo tem uma barra no rodapé: começa verde e vai ficando vermelha conforme o tempo se esgota.
              </p>
              <p className="mb-1">
                <span className="badge badge-success mr-2">No prazo</span>
                tempo confortável
              </p>
              <p className="mb-1">
                <span className="badge badge-warning mr-2">Alerta</span>
                faltam cerca de 2 minutos
              </p>
              <p className="mb-0">
                <span className="badge badge-danger mr-2">Atrasada</span>
                prazo excedido — a linha inteira fica em destaque e o entregador é avisado no aplicativo
              </p>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card className="card-box h-100">
            <CardContent>
              <h6 className="font-weight-bold mb-2">Priorizar e resumir</h6>
              <ul className="pl-3 mb-0">
                <li className="mb-1">
                  Use
                  {' '}
                  <strong>Priorizar em risco</strong>
                  {' '}
                  para trazer atrasadas e próximas do zero para o topo.
                </li>
                <li>
                  O resumo acima da lista mostra quantas corridas estão no prazo, em alerta ou atrasadas,
                  por aguardando, coleta e entrega.
                </li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card className="card-box h-100">
            <CardContent>
              <h6 className="font-weight-bold mb-2">Detalhe da chamada</h6>
              <ul className="pl-3 mb-0">
                <li className="mb-1">Ao abrir a chamada, confira os prazos de coleta e de cada destino.</li>
                <li>Atraso na coleta aponta espera no estabelecimento; atraso na entrega aponta a rota.</li>
              </ul>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Card className="card-box mt-2 mb-3">
        <CardContent>
          <h6 className="font-weight-bold mb-2">Aviso ao entregador</h6>
          <p className="mb-2">
            Quando um prazo de
            {' '}
            <strong>coleta</strong>
            {' '}
            ou
            {' '}
            <strong>entrega</strong>
            {' '}
            não é cumprido, o entregador atribuído recebe um
            {' '}
            <strong>alerta no aplicativo</strong>
            , no mesmo formato dos avisos já existentes.
          </p>
          <p className="mb-0">
            Em chamada
            {' '}
            <strong>Encaminhada</strong>
            , o alerta vai para o entregador do encaminhamento, mesmo que ele ainda não tenha aceito. Em
            {' '}
            <strong>Aguardando</strong>
            {' '}
            sem condutor, só o gestor é avisado no painel.
          </p>
        </CardContent>
      </Card>

      <div className="alert alert-warning py-2 px-3 mt-3 mb-3" role="alert">
        <strong>Versão beta:</strong>
        {' '}
        o monitoramento de prazos pode sofrer ajustes.
      </div>

      <Box display="flex" justifyContent="flex-end">
        <Button variant="contained" color="primary" onClick={onClose}>
          Entendi
        </Button>
      </Box>
    </DialogContent>
  </Dialog>
);

export default SlaInstructionModal;
